import Card from './styled';

export default Card;
